import React, { FC } from 'react';
import { css } from '@emotion/css';

export interface CalculatorNetProfitProps {
  label: string;
  value: string | number;
}

const CalculatorNetProfit: FC<CalculatorNetProfitProps> = (props) => {
  const { label, value } = props;
  return (
    <div className={styles.root}>
      <span className={styles.label}>{label}</span>
      <span className={styles.value}>{value}</span>
    </div>
  );
};

const styles = {
  root: css`
    display: flex;
    gap: 32px;
    justify-content: flex-end;
    padding: 16px 0 0;
  `,
  label: css`
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    color: rgba(51, 51, 51, 0.8);
  `,
  value: css`
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    color: #333;
  `,
};

export default CalculatorNetProfit;
